import React, { FC } from "react";
import {
  MAX_DISPLAYABLE_VIDEO_FILE_NAME_LENGTH,
  MediaFilePreview,
} from "component-library";
import { ISubmissionMedia } from "shared/models/selfTapeRequest";
import "./SelfTapeRequestInfoSubmission.scss";

interface ISelfTapeRequestInfoSubmissionProps {
  submissionMedia: ISubmissionMedia;
}

export const SelfTapeRequestInfoSubmission: FC<
  React.PropsWithChildren<ISelfTapeRequestInfoSubmissionProps>
> = ({ submissionMedia }) => {
  const { title, comments, mediaInfoId } = submissionMedia;

  return (
    <div className="g-content-area c-self-tape-request-info-submission__media-list-item">
      <div className="c-self-tape-request-info-submission__video-thumb g-col-lg-3 g-col-md-3">
        <MediaFilePreview
          id={mediaInfoId}
          fileNameLength={MAX_DISPLAYABLE_VIDEO_FILE_NAME_LENGTH}
        />
      </div>
      <div className="c-self-tape-request-info-submission__video-info g-col-lg-9 g-col-md-9">
        <span className="c-self-tape-request-info-submission__video-title">
          {title}
        </span>
        <span className="c-self-tape-request-info-submission__video-comment">
          {comments}
        </span>
      </div>
    </div>
  );
};
